import { AGENT_ROUTE_NAMES } from '@/agent/types/router'
import { type RouteRecordRaw } from 'vue-router'
import ctiRoutes from '@/cti/routes'
import { agentBeforeEnter, contextualSearchBeforeEnter } from '@/router/guards'

const AgentView = () => import('@/agent/views/AgentView.vue')
const LegacyView = () => import('@/common/views/LegacyView.vue')
const CaseListView = () => import('@/agent/views/CaseListView.vue')
const CaseView = () => import('@/agent/views/CaseView.vue')
const BaseHeader = () => import('@/agent/components/headers/BaseHeader.vue')
const CustomerView = () => import('@/agent/views/CustomerView.vue')
const NewCustomerView = () => import('@/agent/views/NewCustomerView.vue')
const CaseConverterView = () => import('@/agent/views/CaseConverterView.vue')
const SupervisionHeader = () => import('@/agent/components/headers/SupervisionHeader.vue')

export default [
  {
    path: '/assist',
    component: AgentView,
    beforeEnter: agentBeforeEnter,
    meta: {
      agent: true,
      legacy: true,
    },
    children: [
      ...ctiRoutes,
      {
        path: 'ticket/show/:caseId',
        component: CaseView,
        name: AGENT_ROUTE_NAMES.CASE_PROCESSING,
        meta: {
          allowBackNavigation: true,
          exclude: ['/assist/ticket/save'],
        },
      },
      {
        path: 'tickets/list',
        component: CaseListView,
        name: AGENT_ROUTE_NAMES.TICKET_LIST,
        beforeEnter: [contextualSearchBeforeEnter],
        meta: {
          exclude: ['/assist/tickets/bulk/bulkSave'],
        },
      },
      {
        path: 'customer/new',
        name: AGENT_ROUTE_NAMES.CUSTOMER_NEW,
        component: NewCustomerView,
        meta: {
          exclude: ['/assist/customer/save'],
          allowBackNavigation: true,
        },
      },
      {
        path: 'customer/edit/:customerId',
        component: CustomerView,
        props: (route) => ({
          customerId: route.params.customerId,
        }),
        meta: {
          exclude: ['/assist/customer/delete', '/assist/customer/save'],
          allowBackNavigation: true,
        },
      },
      {
        path: ':channel/create/:id',
        component: CaseConverterView,
        meta: {
          exclude: ['/assist/sms/save', '/assist/whatsapp/save'],
          allowBackNavigation: true,
          skipHistory: true,
        },
      },
    ],
  },
  {
    path: '/assist',
    component: LegacyView,
    beforeEnter: agentBeforeEnter,
    meta: {
      legacy: true,
      agent: true,
    },
    children: [
      {
        path: 'ticket/create/oneclick/:skillGroupId',
        component: BaseHeader,
        meta: {
          allowBackNavigation: true,
          skipHistory: true,
        },
      },
      {
        path: 'pause/start/:id',
        component: BaseHeader,
        props: {
          menu: false,
          redirectToHomePage: null,
        },
      },
      {
        path: 'user/myprofile',
        component: BaseHeader,
        props: {
          menu: true,
        },
      },
    ],
  },
  {
    path: '/assist',
    component: LegacyView,
    meta: {
      legacy: true,
    },
    children: [
      {
        path: 'stats/:url+',
        component: BaseHeader,
        props: {
          menu: true,
        },
      },
      {
        path: 'stats/supervision/users',
        component: SupervisionHeader,
        props: {
          menu: true,
        },
      },
      {
        path: 'stats/supervision/connections',
        component: SupervisionHeader,
        props: {
          menu: true,
        },
      },
      {
        path: 'imports/init',
        component: BaseHeader,
        props: {
          menu: true,
        },
      },
      {
        path: 'exclusions/init',
        component: BaseHeader,
        props: {
          menu: true,
        },
      },
    ],
  },
] as Array<RouteRecordRaw>
